import {containsAllEvery, formatDate, getSafeFloat, isArray, isIntType, isObject, isString} from "../../utils";

/**
 * 过滤视图的数据...
 */
export const applyFilterTableView = (arrayDatas:any,tableView:any)=>{
    if (!tableView?.conditions) {
        return arrayDatas;
    }
    const arrayNewData = [];
    const arrayConditions = tableView.conditions;
    for (let k=0;k<arrayDatas.length;k++){
        const data = arrayDatas[k];
        let bOk = true;
        for (let i=0;i<arrayConditions.length;i++){
            const condition = arrayConditions[i];
            let propertyData = data[condition.columnId];

            let propertyValue:any = propertyData;
            if (isObject(propertyData)){
                //如果是文本
                if ((propertyData.type == 'select' || propertyData.type == 'multiSelect' || isArray(propertyData))){
                    propertyValue = propertyData;
                }else{
                    propertyValue = (propertyData.text || '') + '';//变成字符串。。。。。
                }
            }
            //如果条件没有值，并且不是empty,notempty 忽略这个条件
            if (!condition.value && (condition?.operator != 'isEmpty' || condition?.operator != 'isNotEmpty')){
                if (condition.operator == 'isEmpty'){
                    if (isArray(propertyValue)){
                        if (propertyValue.length > 0){
                            //有值
                            bOk = false;
                            break;
                        }
                    }else {
                        if (propertyValue) {
                            //有值
                            bOk = false;
                            break;
                        }
                    }
                }else if (condition.operator == 'isNotEmpty'){
                    if (!propertyValue || (isArray(propertyValue) && propertyValue.length == 0)){
                        bOk = false;
                        break;
                    }
                }
                continue;
            }


            if (propertyValue || isArray(propertyData)){
                if (condition.operator == 'isEmpty'){
                    if (propertyData){
                        bOk = false;
                        break;
                    }
                }

                if (condition.value){
                    if (propertyData?.type == 'number' || propertyData?.type == 'rating'){
                        //region 数字类型
                        const fNumberValue = getSafeFloat(propertyValue);
                        const fConditionValue = getSafeFloat(condition.value);
                        if (condition.operator == '='){
                            if (fConditionValue != fNumberValue){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == '≠'){
                            if (fConditionValue == fNumberValue){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == '>'){
                            if (fNumberValue <= fConditionValue){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == '≥'){
                            if (fNumberValue < fConditionValue){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == '<'){
                            if (fNumberValue >= fConditionValue){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == '≤'){
                            if (fConditionValue < fNumberValue){
                                bOk = false;
                                break;
                            }
                        }
                        //endregion
                    }else if (condition.type == 'date' || propertyData?.type == 'date'){
                        //region 日期
                        let nPropertyDate:any = formatDate(propertyData?.text || propertyData,'yyyyMMdd');
                        nPropertyDate = parseInt(nPropertyDate);
                        let nConditionDate:any = formatDate(condition.value,'yyyyMMdd');
                        nConditionDate = parseInt(nConditionDate);

                        if (condition.operator == 'equals'){
                            if (nPropertyDate != nConditionDate){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'before'){
                            if (nPropertyDate >= nConditionDate){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'after'){
                            if (nPropertyDate <= nConditionDate){
                                bOk = false;
                                break;
                            }
                        }
                        //endregion
                    }else if (propertyData?.type == 'checkbox'){
                        //region 只有一个操作符 is
                        if (condition.value == 'checked'){
                            if (propertyData?.text != true){
                                bOk = false;
                                break;
                            }
                        }else if (condition.value == 'unchecked'){
                            if (propertyData?.text){
                                bOk = false;
                                break;
                            }
                        }
                        //endregion
                    }else if (isArray(propertyData) || propertyData?.type == 'select' || propertyData?.type == 'multiSelect'){
                        //region 多选----
                        let arrayConditionValue = condition.value;
                        const arrayStrData:any = [];
                        propertyData.forEach(ppp=>{
                            arrayStrData.push(ppp.text || ppp);
                        })
                        if (condition.operator == 'is'){
                            if (JSON.stringify(arrayConditionValue) != JSON.stringify(arrayStrData)){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'isNot'){
                            if (JSON.stringify(arrayConditionValue) == JSON.stringify(arrayStrData)){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'contains'){
                            if (!containsAllEvery(arrayStrData,arrayConditionValue)){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'doesNotContain'){
                            if (containsAllEvery(arrayStrData,arrayConditionValue)){
                                bOk = false;
                                break;
                            }
                        }
                        //endregion
                    }else if (condition?.type == 'tags' || propertyData?.type == 'tags'){
                        propertyValue = propertyValue?.toLowerCase();
                        let szConditionValue = condition.value.toLowerCase();
                        if (condition.operator == 'is'){
                            if (szConditionValue != propertyValue){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'isNot'){
                            if (szConditionValue == propertyValue){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'contains'){
                            if (!propertyValue.includes(szConditionValue)){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'doesNotContain'){
                            if (propertyValue.includes(szConditionValue)){
                                bOk = false;
                                break;
                            }
                        }
                    }else if (condition?.type == 'type' || propertyData?.type == 'type'){
                        //region 多选----
                        let arrayConditionValue = condition.value;
                        const arrayStrData:any = [propertyData];//这个是类型...
                        if (condition.operator == 'is'){
                            if (JSON.stringify(arrayConditionValue) != JSON.stringify(arrayStrData)){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'isNot'){
                            if (JSON.stringify(arrayConditionValue) == JSON.stringify(arrayStrData)){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'contains'){
                            if (!containsAllEvery(arrayStrData,arrayConditionValue)){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'doesNotContain'){
                            if (containsAllEvery(arrayStrData,arrayConditionValue)){
                                bOk = false;
                                break;
                            }
                        }
                        //endregion
                    }
                    else{
                        //region 字符串类型
                        propertyValue = propertyValue?.toLowerCase();
                        let szConditionValue = condition.value.toLowerCase();
                        if (condition.operator == 'is'){
                            if (szConditionValue != propertyValue){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'isNot'){
                            if (szConditionValue == propertyValue){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'contains'){
                            if (!propertyValue.includes(szConditionValue)){
                                bOk = false;
                                break;
                            }
                        }else if (condition.operator == 'doesNotContain'){
                            if (propertyValue.includes(szConditionValue)){
                                bOk = false;
                                break;
                            }
                        }
                        //endregion
                    }
                }else{
                    //region 没有条件值

                    //endregion
                }
            } else{
                //region 没有数据值
                if (condition.operator == 'isNotEmpty'){
                    bOk = false;
                    break;
                }else if (condition.operator == 'isEmpty'){

                }else{
                    if (condition?.type == 'number' || condition?.type == 'rating'){
                        if (condition.operator == '≠'){

                        }else{
                            bOk = false;
                            break;
                        }
                    }else if (condition?.type == 'date'){
                        bOk = false;
                        break;
                    }else if (condition?.type == 'checkbox'){
                        if (condition.value == 'checked'){
                            bOk = false;
                            break;
                        }
                    }else{
                        if (condition?.operator == 'isNot' || condition.operator == 'doesNotContain'){

                        }else{
                            bOk = false;
                            break;
                        }
                    }
                }
                //endregion
            }
        }
        if (bOk){
            arrayNewData.push(data);
        }
    }

    return arrayNewData;
}